<div class="element-detail-inner">
  <div class="heading text-xs"></div>
  <div class="heading text-xs">Nr</div>
  <div class="heading text-xs">Data spłaty</div>
  <div class="heading text-xs">Kwota</div>
  <div class="heading text-xs">Status</div>
  <ng-container *ngFor="let item of value.paymentSchedule">
    <div class="nowrap">
      <app-icon *ngIf="shoudBeChecked(item)"
                [color]="getColor(item.status)"
                name="check"
                [width]="13"
                [height]="13"></app-icon>
    </div>

    <div
      class="nowrap"
      [ngClass]="{ 'status-repayment-break': item.status === Status.REPAYMENT_BREAK, 'status-overdue':
      item.status === Status.OVERDUE }"
      [ngStyle]="{'font-weight': shoudBeChecked(item) ? 'bold' : null}">
      {{ item.installmentNumber }}
    </div>
    <div
      class="nowrap"
      [ngClass]="{ 'status-repayment-break': item.status === Status.REPAYMENT_BREAK, 'status-overdue':
      item.status === Status.OVERDUE }"
      [ngStyle]="{'font-weight': shoudBeChecked(item) ? 'bold' : null}">
      {{ item.paymentDate | date: 'dd.MM.yyyy': '':'pl' }}
    </div>
    <div
      class="nowrap"
      [ngClass]="{ 'status-repayment-break': item.status === Status.REPAYMENT_BREAK, 'status-overdue':
      item.status === Status.OVERDUE }"
      [ngStyle]="{'font-weight': shoudBeChecked(item) ? 'bold' : null}">
      {{ item.amount | paykaCurrency }}
    </div>
    <div
      class="nowrap"
      [ngClass]="{ 'status-repayment-break': item.status === Status.REPAYMENT_BREAK, 'status-overdue':
      item.status === Status.OVERDUE }"
      [ngStyle]="{'font-weight': shoudBeChecked(item) ? 'bold' : null}">
      {{ this.statuses[item.status] }}
    </div>
  </ng-container>
  <div *ngIf="(value.interest>0)" class="full-row interests text-sm">Odsetki za opoznienie {{ value.interest + ' zł' }}
  </div>
  <div class="full-row">
    <div class="links" fxLayout="row" fxLayoutAlign="space-around center">
      <button class="link nowrap"
              [disabled]="isDisabledPaymentLink()"
              [ngClass]="{'disabled-link': isDisabledPaymentLink() }"
              (click)="getLinkToRepaymentEntireAgreement()">Spłać całość
      </button>
      <button class="link nowrap" (click)="onDownloadFileClick()"
              [ngClass]="{'disabled-link': isDisabledDownloadLink() }"
              [disabled]="isDisabledDownloadLink()">Pobierz umowę
      </button>
      <button [ngClass]="{'disabled-link': isDisabledDetailsLink() }"
              [disabled]="isDisabledDetailsLink()"
              class="link nowrap" (click)="onGoToDefermentClick()">Szczegóły
      </button>
    </div>
  </div>
</div>

